import { Component, computed, effect, inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OrganizationsService } from '@evc/platform';
import { toSignal } from '@angular/core/rxjs-interop';
import { ButtonComponent } from '@evc/web-components';
import { CurrentUserService } from '@core/services/current-user.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-wrong-organization',
  templateUrl: './wrong-organization.component.html',
  styleUrls: ['./wrong-organization.component.scss'],
  imports: [TranslateModule, ButtonComponent],
})
export class WrongOrganizationComponent {
  #route = inject(ActivatedRoute);
  #router = inject(Router);
  #organizationsService = inject(OrganizationsService);
  #currentUserService = inject(CurrentUserService);

  readonly #queryParams = toSignal(this.#route.queryParams, { initialValue: {} as Params });

  public readonly targetOrgId = computed(() => this.#queryParams().targetOrgId as string | undefined);
  public readonly hasAccess = computed(() => this.#queryParams().hasAccess === 'true');
  public readonly returnUrl = computed(() => this.#queryParams().returnUrl as string | undefined);

  public readonly targetOrgName = computed(() => {
    const id = this.targetOrgId();
    if (!id) {
      return undefined;
    }
    return this.#organizationsService.entries().find(org => org.id === id)?.name;
  });

  public constructor() {
    this.#redirectWhenLandingOnCorrectOrganization();
  }

  public onSwitchOrganization(): void {
    const targetOrgId = this.targetOrgId();
    if (!targetOrgId) {
      return;
    }
    firstValueFrom(this.#organizationsService.setCurrent(targetOrgId, true));
  }

  public onGoHome(): void {
    this.#router.navigateByUrl('/');
  }

  #redirectWhenLandingOnCorrectOrganization() {
    effect(() => {
      const currentUser = this.#currentUserService.currentUser();
      if (!currentUser) {
        return;
      }
      const targetOrgId = this.targetOrgId();
      if (targetOrgId === currentUser.organizationId) {
        this.#router.navigateByUrl(this.returnUrl() || '/', { replaceUrl: true });
      }
    });
  }
}
